/* istanbul ignore file */
import { array as codecArray, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CoursePermission } from './CoursePermission';
const RemovedPermissionsParser = /* #__PURE__ */ parsers.object([
    ['course', /* #__PURE__ */ parsers.setFromArray(codecArray(CoursePermission))],
    [
        'global',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.setFromArray(codecArray(codecString))),
    ],
]);
export class RemovedPermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RemovedPermissionsParser.decode(input).map(res => new RemovedPermissions(res));
    }
    static unsafeDecode(input) {
        return RemovedPermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RemovedPermissionsParser.encode(data);
    }
    static schema() {
        return RemovedPermissionsParser.schema();
    }
}
